// defs
import {
    CreatePennyTransactionResponse,
    OrderData,
    PAYMENT_CODES,
    ALWAYS_POLL_PAYMENT_METHODS,
    CONDITIONALLY_POLL_PAYMENT_METHODS,
} from "@swiggy-private/payment-types";

// constants
import { POLLING_CONFIG } from "@payment-client/constants/Options";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";
import { getCredPaymentPollingDuration } from "./CredHelper";
import { getUpiCollectPollingDuration, getUpiIntentPollingDuration } from "./UpiHelper";

export const getPollingIntervalInMs = (paymentCode: string, orderData?: OrderData) => {
    if (!isEmpty(orderData?.pollingIntervalInMs)) {
        return Number(orderData?.pollingIntervalInMs);
    }

    if (paymentCode === PAYMENT_CODES.UPICOLLECT) {
        return POLLING_CONFIG.pollingIntervalInMS;
    }

    return POLLING_CONFIG.txnStatusPollingIntervalInMS;
};

export const getPollingDurationInMs = (paymentCode: string, orderData?: OrderData) => {
    if (paymentCode === PAYMENT_CODES.CRED) {
        return getCredPaymentPollingDuration(orderData);
    } else if (paymentCode === PAYMENT_CODES.UPIINTENT) {
        return getUpiIntentPollingDuration(orderData);
    } else if (paymentCode === PAYMENT_CODES.UPICOLLECT) {
        return getUpiCollectPollingDuration(orderData);
    }

    return (Number(orderData?.confirmationTimeMinutes) || 0) * 60 * 1000 || POLLING_CONFIG.defaultCardPollingDuration;
};

export const shouldPollForTxnStatus = (orderData: OrderData, methodName?: string) => {
    const _methodName = (methodName ?? "").toUpperCase();

    if (ALWAYS_POLL_PAYMENT_METHODS.has(_methodName)) {
        return true;
    }

    if (!CONDITIONALLY_POLL_PAYMENT_METHODS.has(_methodName)) {
        return false;
    }

    const mins = Number(orderData.confirmationTimeMinutes);
    return Number.isFinite(mins) && mins > 0;
};

export const shouldPollForPennyTxnStatus = (transaction: CreatePennyTransactionResponse) => {
    const interval = Number(transaction?.pollingIntervalInMs);
    const duration = Number(transaction?.maxTimeToPollForInMs);
    return Number.isFinite(interval) && interval > 0 && Number.isFinite(duration) && duration > 0;
};

export const getPollingConfiguration = (paymentCode: string, orderData: OrderData) => {
    return {
        pollingIntervalInMs: getPollingIntervalInMs(paymentCode, orderData),
        pollingDurationInMs: getPollingDurationInMs(paymentCode, orderData),
    };
};
